import { QuestionType } from '@app/core/model/enums/question-type.enum'
import { formatDateIntoUTC } from '@app/shared/components/ui-components/scope-ui-datepicker/scope-ui-datepicker.const'
import { isNil } from 'lodash'

export const getQuestionValueByType = (type: QuestionType, value: any, dateFormat?: string) => {
  switch (type) {
    case QuestionType.DATE:
      return value ? formatDateIntoUTC(value, dateFormat) : null
    case QuestionType.NUMBER:
      return !isNil(value) ? +value : null
    default:
      return !isNil(value) && value !== '' ? value : null
  }
}
